import { canAccessInsights } from './canAccessInsights';
import { computedFieldSummary } from './computedFieldSummary';
import { configurationMap } from './configurationMap';
import { domainSettings } from './domainSettings';
import { generateRejectionEmail } from './generateRejectionEmail';
import { getMetabaseJWT } from './getMetabaseJWT';
import { saveLogs } from './logs';
import { reautomate } from './reautomate';
import { reportSummary } from './reportSummary';
import { requestDemo } from './requestDemo';
import { requestExtension } from './requestExtension';
import { evaluateRules } from './rules/evaluateRules';
import { suggestRule } from './rules/suggestRule';
import { suggestTriggerCondition } from './rules/suggestTriggerCondition';
import { suggestTriggerConditionSummary } from './rules/suggestTriggerConditionSummary';
import { evaluateFormulas } from './schemas/evaluateFormulas';
import { formulasInfo } from './schemas/formulasInfo';
import { formulaSummary } from './schemas/formulaSummary';
import { suggestComputedField } from './schemas/suggestComputedField';
import { suggestFormula } from './schemas/suggestFormula';
import { suggestReport } from './suggestReport';

export {
  type DomainSettingsResponse,
  type DomainSettingsSsoProvider,
} from './domainSettings';
export {
  type ComputedFieldSummaryPayload,
  type ComputedFieldSummaryResponse,
  type QuerySummary,
  type SummaryBlock,
} from './computedFieldSummary';
export {
  type ConfigurationMapEdge,
  type ConfigurationMapField,
  type ConfigurationMapHook,
  type ConfigurationMapPayload,
  type ConfigurationMapResponse,
  type ConfigurationMapRule,
} from './configurationMap';
export { type GenerateRejectionPayload } from './generateRejectionEmail';
export { type ReautomatePayload, type ReautomateResponse } from './reautomate';
export { type RequestDemoPayload } from './requestDemo';
export { type RequestExtensionPayload } from './requestExtension';
export { type EvaluateRulesResponse } from './rules/evaluateRules';
export { type SuggestRuleResponse } from './rules/suggestRule';
export { type SuggestTriggerConditionResponse } from './rules/suggestTriggerCondition';
export { type SuggestTriggerConditionResult } from './rules/suggestTriggerCondition';
export {
  type AutomationBlocker,
  type EvaluateFormulasResponse,
} from './schemas/evaluateFormulas';
export { type SuggestFormulaResponse } from './schemas/suggestFormula';
export { type SuggestComputedFieldResponse } from './schemas/suggestComputedField';
export { type ReportSummaryPayload } from './reportSummary';

// Typescript is very sad when the types are too big.
// Same problem as in api-client/index.ts, see comment there

const schemasEndpoints1 = {
  evaluateFormulas,
  formulasInfo,
};

const schemasEndpoints2 = {
  suggestFormula,
  formulaSummary,
  suggestComputedField,
};

const rulesEndpoints1 = {
  suggestRule,
  suggestTriggerCondition,
};

const rulesEndpoints2 = {
  suggestTriggerConditionSummary,
  evaluateRules,
};

/**
 * @noSchema
 */
type SchemasEndpoints = typeof schemasEndpoints1 & typeof schemasEndpoints2;

const internalSchemas: {
  schemas: SchemasEndpoints;
} = {
  schemas: {
    ...schemasEndpoints1,
    ...schemasEndpoints2,
  },
};

/**
 * @noSchema
 */
type RulesEndpoints = typeof rulesEndpoints1 & typeof rulesEndpoints2;

const internalRules: {
  rules: RulesEndpoints;
} = {
  rules: { ...rulesEndpoints1, ...rulesEndpoints2 },
};

export const internal = {
  requestDemo,
  requestExtension,
  domainSettings,
  generateRejectionEmail,
  saveLogs,
  suggestReport,
  reportSummary,
  reautomate,
  computedFieldSummary,
  configurationMap,
  getMetabaseJWT,
  canAccessInsights,
  ...internalSchemas,
  ...internalRules,
};
